import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { AlertTriangle, Phone, Check, Clock, Shield, MapPin } from "lucide-react";
import { Button } from "@/components/ui/button";

const PHONE_NUMBER = "306-262-5995";

const EmergencyPage = () => {
  const services = [
    { title: "Home Lockouts", desc: "Locked out of your house? We'll get you back inside quickly." },
    { title: "Car Lockouts", desc: "Keys locked in your car? Fast mobile service to your location." },
    { title: "Business Lockouts", desc: "Don't lose business hours - we respond fast to commercial lockouts." },
    { title: "Broken Key Emergencies", desc: "Key broke in the lock? We'll extract it and get you access." },
    { title: "Lock Repairs", desc: "Lock damaged or not working? Emergency repair service available." },
    { title: "Security Emergencies", desc: "Break-in? We provide emergency lock changes and security upgrades." },
  ];

  return (
    <div className="min-h-screen bg-slate-900">
      <Header />
      
      {/* Hero */}
      <section className="pt-32 pb-20 px-4 md:px-8 relative bg-red-900/20">
        <div className="max-w-7xl mx-auto text-center relative z-10">
          <div className="inline-flex items-center gap-2 bg-red-600 rounded-sm px-6 py-3 mb-6 animate-pulse">
            <AlertTriangle className="w-6 h-6 text-white" />
            <span className="text-white font-bold text-lg">24/7 EMERGENCY SERVICE</span>
          </div>
          <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl text-white mb-6">
            Emergency Locksmith <span className="text-amber-400">Saskatoon</span>
          </h1>
          <p className="text-slate-300 text-lg max-w-2xl mx-auto mb-8">
            Locked out? Don't panic! We're available 24 hours a day, 7 days a week. Fast 15-30 minute response time.
          </p>
          <a href={`tel:${PHONE_NUMBER.replace(/-/g, "")}`}>
            <Button className="bg-amber-500 hover:bg-amber-600 text-slate-900 font-bold text-2xl px-12 py-8 animate-pulse">
              <Phone className="w-8 h-8 mr-3" />
              CALL NOW: {PHONE_NUMBER}
            </Button>
          </a>
        </div>
      </section>

      {/* Why Call Us */}
      <section className="py-20 px-4 md:px-8">
        <div className="max-w-7xl mx-auto">
          <h2 className="font-heading text-3xl text-white text-center mb-12">Why Call 306 Locksmith?</h2>
          <div className="grid md:grid-cols-4 gap-6">
            <div className="bg-slate-800 border border-slate-700 rounded-sm p-6 text-center">
              <Clock className="w-12 h-12 text-amber-400 mx-auto mb-4" />
              <h3 className="text-white font-bold text-xl mb-2">15-30 Min Response</h3>
              <p className="text-slate-400">We arrive fast when you need us most.</p>
            </div>
            <div className="bg-slate-800 border border-slate-700 rounded-sm p-6 text-center">
              <Shield className="w-12 h-12 text-amber-400 mx-auto mb-4" />
              <h3 className="text-white font-bold text-xl mb-2">No Hidden Fees</h3>
              <p className="text-slate-400">Price quoted is the price you pay.</p>
            </div>
            <div className="bg-slate-800 border border-slate-700 rounded-sm p-6 text-center">
              <MapPin className="w-12 h-12 text-amber-400 mx-auto mb-4" />
              <h3 className="text-white font-bold text-xl mb-2">Local Service</h3>
              <p className="text-slate-400">Saskatoon & surrounding areas covered.</p>
            </div>
            <div className="bg-slate-800 border border-slate-700 rounded-sm p-6 text-center">
              <AlertTriangle className="w-12 h-12 text-amber-400 mx-auto mb-4" />
              <h3 className="text-white font-bold text-xl mb-2">24/7 Available</h3>
              <p className="text-slate-400">Day, night, weekends & holidays.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Emergency Services */}
      <section className="py-20 px-4 md:px-8 bg-slate-800">
        <div className="max-w-7xl mx-auto">
          <h2 className="font-heading text-3xl text-white text-center mb-12">Emergency Services We Provide</h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {services.map((service, idx) => (
              <div key={idx} className="bg-slate-700 border border-slate-600 rounded-sm p-6">
                <div className="w-12 h-12 bg-red-500/20 rounded-sm flex items-center justify-center mb-4">
                  <Check className="w-6 h-6 text-red-400" />
                </div>
                <h3 className="text-white font-bold text-xl mb-2">{service.title}</h3>
                <p className="text-slate-400">{service.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Big CTA */}
      <section className="py-20 px-4 md:px-8 bg-red-600">
        <div className="max-w-4xl mx-auto text-center">
          <AlertTriangle className="w-16 h-16 text-white mx-auto mb-6" />
          <h2 className="font-heading text-4xl text-white mb-4">DON'T WAIT - CALL NOW!</h2>
          <p className="text-red-100 text-xl mb-8">Our emergency team is standing by 24/7</p>
          <a href={`tel:${PHONE_NUMBER.replace(/-/g, "")}`}>
            <Button className="bg-white hover:bg-slate-100 text-red-600 font-bold text-2xl px-12 py-8">
              <Phone className="w-8 h-8 mr-3" />
              {PHONE_NUMBER}
            </Button>
          </a>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default EmergencyPage;
